/**
 * @description 字典状态管理
 * @author zhijie.huang
 * @date 2018/9/19
 */

import DicBiz from '../logic/dictionaryBiz'

export default {
  state: {
    data: {},
    app: {},
    group: {}
  },
  mutations: {
    update(state, payload) {
      const name = payload.name
      const val = payload.val
      // TODO 是否需要判断？
      if (!state[name]) {
        state.data[name] = val
      }
    },
    updateGroup(state, payload) {
      const val = payload.val
      state.group = val
    },
    updateApp(state, payload) {
      const name = payload.name
      const val = payload.val
      // TODO 是否需要判断？
      if (!state[name]) {
        state.app[name] = { ...val }
      }
    }
  },
  actions: {
    getByCode(context, payload) {
      const code = payload.code
      const flag = payload.flag

      if (context.state.data[code]) return Promise.resolve(undefined)

      return DicBiz.searchDictionaryByCode(code, flag).then((data) => {
        context.commit('update', {
          name: code,
          val: data
        })
      })
    },
    getGroup(context, payload) {
      if (!payload.siteChange && context.state.group && Object.keys(context.state.group).length > 0) return Promise.resolve(undefined)
      return DicBiz.searchGroupBySiteCode(payload.siteCode).then((data) => {
        context.commit('updateGroup', {
          val: data
        })
      })
    },
    resetGroup(context, payload) {
      return DicBiz.searchGroupBySiteCode(payload.siteCode).then((data) => {
        context.commit('updateGroup', {
          val: data
        })
      })
    },
    getAppByGroup(context, payload) {
      const group = payload.group
      const siteCode = payload.siteCode
      if (context.state.app[group]) return Promise.resolve(undefined)

      return DicBiz.searchAppByGroupName(siteCode, group).then((data) => {
        context.commit('updateApp', {
          siteCode: siteCode,
          name: group,
          val: data
        })
      })
    },
    resetAppByGroup(context, payload) {
      const group = payload.group
      const siteCode = payload.siteCode
      return DicBiz.searchAppByGroupName(siteCode, group).then((data) => {
        context.commit('updateApp', {
          siteCode: siteCode,
          name: group,
          val: data
        })
      })
    }
  }
}
